/**
 * Asynchronously loads the component for NotFoundPage
 */

import { lazyLoad } from 'utils/loadable';

export const AreaListPage = lazyLoad(
  () => import('./index'),
  module => module.AreaListPage
);
